import { Injectable } from '@angular/core';
import {
  Messaging,
  getToken,
  onMessage,
  deleteToken,
} from '@angular/fire/messaging';
import { catchError, Observable, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CommonApi } from './api/common.api';
import { ApiUrls } from 'src/app/config/constants';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  private messageSubject = new Subject<any>();
  message$ = this.messageSubject.asObservable();
  fcmToken = '';
  message = '';

  private NotificationBaseUrl = ApiUrls.notifications;

  constructor(
    private msg: Messaging,
    private apiService: CommonApi
  ) { }

  async requestPermission(): Promise<void> {
    const notificationPermissions = await Notification.requestPermission();
    // console.log('Notification permission:', Notification.permission);
    if (notificationPermissions === 'granted') {
      try {
        await this.getToken();
      } catch (error) {
        console.error('Error getting FCM token:', error);
      }
    } else if (notificationPermissions === 'denied') {
      console.log('Notification permission denied');
    }
  }

  getToken(): Promise<void> {
    return new Promise((resolve, reject) => {
      navigator.serviceWorker.register('/assets/firebase-messaging-sw.js')
        .then((serviceWorkerRegistration) => {
          getToken(this.msg, {
            vapidKey: `${environment.firebaseConfig.vapidKey}`,
            serviceWorkerRegistration: serviceWorkerRegistration
          }).then((token) => {
            this.fcmToken = token;
            this.initMessageListener();
            resolve();
          }).catch((error) => {
            console.error(error);
            resolve()
          })
        }).catch((error) => {
          console.error(error);
          resolve()
        })
    })
  }

  initMessageListener() {
    onMessage(this.msg, (payload) => {
      this.messageSubject.next(
        payload.notification
      ); // Emit message body
    });
  }

  async deleteToken() {
    await deleteToken(this.msg);
  }

  getNotifications(shopId: string, status: string): Observable<any> {
    return this.apiService.getData(`${this.NotificationBaseUrl}/${shopId}?status=${status}`).pipe(
      catchError((error) => {
        throw 'Error getting notifications: ' + error;
      })
    );
  }

  updateNotificationStatus(
    shopId: string,
    sStatus: string,
    body: { status: string; notificationId: string }
  ): Observable<any> {
    return this.apiService.putData(`${this.NotificationBaseUrl}/${shopId}?status=${sStatus}`, body)
      .pipe(
        catchError((error) => {
          throw 'Error updating notification status: ' + error;
        })
      );
  }

  deleteNotification(shopId: string, notificationId: string): Observable<any> {
    return this.apiService
      .deleteData(`${this.NotificationBaseUrl}/${shopId}?notificationId=${notificationId}`)
      .pipe(
        catchError((error) => {
          throw 'Error deleting notification: ' + error;
        })
      );
  }
}
